export enum InstanceStatus {
  'INSTANCE_READY' = 'Instance created',
  'SESSION_START' = 'Session start'
}
